export const CFP_SESSION_STATUS = {
  DELETED: 0,
  ACTIVE: 1,
  PAID: 2,
  DONE: 3,
};

const CFP_SESSION_NON_DELETABLE_STATUSES = new Set([
  CFP_SESSION_STATUS.PAID,
  CFP_SESSION_STATUS.DONE,
]);

const CFP_SESSION_EDITABLE_STATUSES = new Set([
  CFP_SESSION_STATUS.ACTIVE,
  CFP_SESSION_STATUS.PAID,
]);

export const isInitialCfpSession = (row) => {
  const status = Number(row?.status);
  return status === CFP_SESSION_STATUS.ACTIVE && !row?.stripe_checkout_session_id;
};

export const canDeleteCfpSession = (row) => {
  const status = Number(row?.status);
  if (CFP_SESSION_NON_DELETABLE_STATUSES.has(status)) return false;
  if (isInitialCfpSession(row)) return false;
  return true;
};

export const canEditCfpSession = (row) => {
  const status = Number(row?.status);
  return CFP_SESSION_EDITABLE_STATUSES.has(status);
};

export const canPayCfpSession = (row) => {
  const status = Number(row?.status);
  return status === CFP_SESSION_STATUS.ACTIVE && Boolean(row?.stripe_checkout_session_id);
};

export const getCfpSessionDeleteDisabledReason = (row, copy) => {
  const messages = copy?.delete_disabled || {};
  const status = Number(row?.status);
  if (isInitialCfpSession(row)) return messages.initial || '';
  if (status === CFP_SESSION_STATUS.PAID) return messages.paid || '';
  if (status === CFP_SESSION_STATUS.DONE) return messages.done || '';
  return null;
};

export const getCfpSessionEditDisabledReason = (row, copy) => {
  const messages = copy?.edit_disabled || {};
  const status = Number(row?.status);
  if (status === CFP_SESSION_STATUS.DONE) return messages.done || '';
  if (!CFP_SESSION_EDITABLE_STATUSES.has(status)) return messages.other || '';
  return null;
};

export const canManageCfpSessionDocuments = (row) => {
  const status = Number(row?.status);
  return status !== CFP_SESSION_STATUS.DONE;
};

export const getCfpSessionDocumentsDisabledReason = (row, copy) => {
  const status = Number(row?.status);
  if (status === CFP_SESSION_STATUS.DONE) {
    return copy?.documents_disabled || '';
  }
  return null;
};

export const getSessionStatusMeta = (row, copy) => {
  const labels = copy?.labels || {};
  const status = Number(row?.status);
  if (status === CFP_SESSION_STATUS.DONE) {
    return { label: labels.done || '', tone: 'done', filterKey: 'done' };
  }
  if (status === CFP_SESSION_STATUS.PAID) {
    return { label: labels.paid || '', tone: 'paid', filterKey: 'paid' };
  }
  if (status === CFP_SESSION_STATUS.ACTIVE && row?.stripe_checkout_session_id) {
    return { label: labels.pending || '', tone: 'pending', filterKey: 'pending' };
  }
  return { label: labels.scheduled || '', tone: 'scheduled', filterKey: 'scheduled' };
};

export const canMarkCfpSessionDone = (row) => {
  const status = Number(row?.status);
  if (status === CFP_SESSION_STATUS.DONE) return false;
  if (status === CFP_SESSION_STATUS.PAID) return true;
  return isInitialCfpSession(row);
};

export const matchesAdminCfpSessionStatusFilter = (row, statusFilter) => {
  const filterKey = getSessionStatusMeta(row).filterKey;
  if (statusFilter === 'paid') {
    return filterKey === 'paid' || filterKey === 'scheduled';
  }
  return filterKey === statusFilter;
};

export const formatCfpSessionTimestamp = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return { date: String(value), time: null };
  return {
    date: date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }),
    time: date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
    }),
  };
};
